import examineTemplate from '../examineTemplate'
import projectCost from '../projectCost'
import PublicBuill from './publicBuill'
import billTitleTemplate from '../billTitleTemplate'
import invoiceTable from '../invoiceTable'

export default {
  components: {
    examineTemplate,
    billTitleTemplate,
    projectCost,
    invoiceTable
  },
  props: {
    property: Object,
    view: String,
    AccountingReview: Boolean,
    toVoid: Boolean
  },
  data() {
    return {
      user: {},
      show: true,
      title: '吴忠仪表销售有限公司费用报销单',
      saleFybxd: {},
      bxnrArr: [],
      fybxdJmbxnrArr: [],
      xsFymxList: [],
      lcPersons: ['', '', '', '', '', '', '', '', '', ''], // 流程人员
      examineTemplate: {
        workflowData: []
      },
      /* 审核需要数据 */
      oaSqdSh: {
        userNo: localStorage.getItem('userNo'),
        isAgree: '',
        shyj: '',
        documentType: 'xsfybxd0',
        flowId: '',
        maindjh: '',
        lb: 'xsfybxd',
        shr: localStorage.getItem('userName'),
        shrNo: localStorage.getItem('userNo'),
        shje: ''
      },
      oldJe: 0,
      invoiceArr: [],
      invoiceDelArr: [],
      invoiceChange: false
    }
  },
  mounted() {
    this.getListBxnr()
    this.initData(this.property)
  },
  created() {
    PublicBuill.setThis(this)
  },
  methods: {
    getListBxnr() {
      this.$post('/fesback/fybxd/getFyBxnr.z').then(response => {
        this.fybxdJmbxnrArr = response
      })
    },
    initData(billDataAll) {
      this.user = localStorage
      const saleFybxd = billDataAll.BillData
      this.oldJe = saleFybxd.je
      this.saleFybxd = saleFybxd
      this.saleFybxd.rq = saleFybxd.rq.split(' ')[0]
      /* 审核使用字段 */
      this.oaSqdSh.maindjh = saleFybxd.djh
      this.oaSqdSh.flowId = saleFybxd.flowId
      this.oaSqdSh.shje = saleFybxd.je
      if (saleFybxd)
        this.xsFymxList = saleFybxd.xsFymxList
      for (let i = 1; i <= 10; i++) {
        if (!saleFybxd['bxnr' + i] || saleFybxd['bxnr' + i] === '') {
          break
        }
        const temp = {
          bxnr: this.saleFybxd['bxnr' + i],
          bxje: this.saleFybxd['bxje' + i]
        }
        this.bxnrArr.push(temp)
      }


      this.saleFybxd.jeDx = PublicBuill.convertCurrency(saleFybxd.je)

      /* 有工作流信息 */
      const examineData = billDataAll.examineData
      if (examineData) {
        const oldShName = {
          xsfybxd09: '集团CFO',
          xsfybxd08:	'集团总裁',
          xsfybxd07:	'董事长',
          xsfybxd06:	'总会计师',
          xsfybxd05:	'总经理',
          xsfybxd04:	'财务部长',
          xsfybxd03:	'副总经理',
          xsfybxd02:	'财务审核',
          xsfybxd01:	'会计核算',
          xsfybxd00:	'商务部长'
        }
        for (let i = 0; i < examineData.length; i++) {
          const val = examineData[i]
          let nodeName = val.lcName
          const liId = val.lcid
          if (!nodeName) {
            nodeName = oldShName[liId]
            val.lcName = nodeName
          }
          if (nodeName === '经办人') {
            val.auditStatus = '提交'
          } else if (val.shbz === '0') {
            val.auditStatus = '退回'
          } else {
            val.auditStatus = '批准'
          }

          if (nodeName !== '经办人') {
            const receivedPersons = val.shr
            if (nodeName === '集团总裁') {
              this.lcPersons[11] = receivedPersons
            } else if (nodeName === '集团CFO') {
              this.lcPersons[10] = receivedPersons
            } else if (nodeName === '总经理') {
              this.lcPersons[9] = receivedPersons
            } else if (nodeName === '董事长') {
              this.lcPersons[8] = receivedPersons
            } else if (nodeName === '总会计师') {
              this.lcPersons[7] = receivedPersons
            } else if (nodeName === '副总经理') {
              this.lcPersons[6] = receivedPersons
            } else if (nodeName === '财务部长') {
              this.lcPersons[5] = receivedPersons
            } else if (nodeName === '财务审核') {
              this.lcPersons[4] = receivedPersons
            } else if (nodeName === '会计核算') {
              this.lcPersons[3] = receivedPersons
            } else if (nodeName === '商务部长') {
              this.lcPersons[2] = receivedPersons
            } else if (nodeName === '销售副总审核') {
              this.lcPersons[1] = receivedPersons
            }
          }
          if (val.shr)
            this.examineTemplate.workflowData.push(val)
          if (i === 0 && nodeName !== '归档' && saleFybxd.recipient)
            this.examineTemplate.workflowData.unshift({ shr: saleFybxd.recipient, auditStatus: '未办理' })
        }
      }
    },
    queryBillData() {
      this.$emit('queryBillData')
      this.saleFybxdColse()
    },
    saleFybxdColse() {
      this.show = false
      this.$emit('saleFybxClose')
    },
    agreeClick() {
      PublicBuill.agreeClick()
    },
    refuseClick() {
      PublicBuill.refuseClick()
    },
    jeChange() {
      let je = 0.0
      let a = false
      this.bxnrArr.forEach(value => {
        if (value.bxje !== '') {
          if (value.bxje <= 0) {
            a = true
            this.$message.error('金额不能小于0')
            return
          }
          if (value.bxje !== null && value.bxje !== '') {
            value.bxje = parseFloat(value.bxje).toFixed(2)
            je = (parseFloat(value.bxje) + parseFloat(je)).toFixed(2)
          }
        }
      })
      if (a) {
        this.saleFybxd.je = 0
      }
      this.saleFybxd.je = je
      this.saleFybxd.jeDx = PublicBuill.convertCurrency(je)
    },
    checkSave() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        djh: this.saleFybxd.djh,
        je: this.saleFybxd.je,
        hsr: localStorage.getItem('userName'),
        fysy: this.saleFybxd.fysy,
        fyms: this.saleFybxd.fyms,
        bz: this.saleFybxd.bz,
        oldJe: this.oldJe
      }

      this.bxnrArr.forEach((value, index) => {
        const bxnr = 'bxnr' + (index + 1)
        const bxje = 'bxje' + (index + 1)
        data[bxnr] = value.bxnr
        if (value.bxje === '') {
          value.bxje = '0.00'
        }
        data[bxje] = value.bxje
      })
      this.xsFymxList.forEach((value, index) => {
        const bxnrmx = ''
        const bxjemx = 0.00
        data[bxnrmx] = value.sx
        data[bxjemx] = value.je
      })
      Promise.all([
        this.saveData(data),
        this.saveInvoice()
      ]).then(res => {
        for (const element of res) {
          if (!element.success) {
            this.$message.error(element.message)
          }
        }
        loading.close()
        this.$message.success('数据更新完成。')
      })
    },
    async saveData(data) {
      return await this.$post('/fesback/fybxd/editXsFybxd.z', data).then(response => {
        if (response.success) {
          this.queryBillData()
          this.saleFybxdColse()
        }
        return response
      }).catch(err => {
        return { message: '非预期错误' + err, success: false }
      })
    },
    async saveInvoice() {
      if (this.invoiceDelArr && this.invoiceDelArr.length > 0) {
        const r2 = await PublicBuill.deleteInvoiceByInfo(this.invoiceDelArr)
        if (!r2.success) {
          return r2
        }
      }
      if (this.invoiceArr.length > 0) {
        const r1 = await PublicBuill.vatInvoiceUpload(this.saleFybxd.djh)
        if (!r1.success) {
          return r1
        }
      }
      return { success: true, message: '更新完成' }
    },
    updateInvoice(val) {
      this.invoiceArr = val
      this.invoiceChange = true
    },
    delInvoice(val) {
      val.forEach(val => {
        this.invoiceDelArr.push(val)
      })
    },
    /* 报销内容 */
    addBxnr() {
      const temp = {
        bxnr: '',
        bxje: ''
      }
      if (this.bxnrArr.length <= 7) {
        this.bxnrArr.push(temp)
      }
    },
    reduceBxnr() {
      if (this.bxnrArr.length >= 2) {
        this.bxnrArr.pop()

        let je = 0.0
        this.bxnrArr.forEach(value => {
          if (value.bxje !== null && value.bxje !== '')
            je = (parseFloat(value.bxje) + parseFloat(je)).toFixed(2)
        })
        this.saleFybxd.je = je
        this.saleFybxd.jedx = PublicBuill.convertCurrency(je)
      }
    }

  }
}
